var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveDocumentFlexiLoan({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2923 16.6719C17.2923 17.2794 17.0507 17.8627 16.6215 18.2927C16.1915 18.7219 15.6082 18.9635 15.0007 18.9635H5.00065C4.39315 18.9635 3.80982 18.7219 3.37982 18.2927C2.95065 17.8627 2.70898 17.2794 2.70898 16.6719V3.33854C2.70898 2.73104 2.95065 2.14771 3.37982 1.71771C3.80982 1.28854 4.39315 1.04688 5.00065 1.04688H12.1557C12.5423 1.04688 12.9132 1.20021 13.1865 1.47438L16.8648 5.15271C17.139 5.42604 17.2923 5.79688 17.2923 6.18354V16.6719ZM16.0423 16.6719V6.18354C16.0423 6.12854 16.0207 6.07521 15.9815 6.03604L12.3032 2.35771C12.264 2.31854 12.2107 2.29688 12.1557 2.29688H5.00065C4.72398 2.29688 4.45982 2.40688 4.26398 2.60188C4.06898 2.79771 3.95898 3.06188 3.95898 3.33854V16.6719C3.95898 16.9485 4.06898 17.2127 4.26398 17.4085C4.45982 17.6035 4.72398 17.7135 5.00065 17.7135H15.0007C15.2773 17.7135 15.5415 17.6035 15.7373 17.4085C15.9323 17.2127 16.0423 16.9485 16.0423 16.6719Z",
    fill: "#00B3B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.875 2.07812C11.875 1.73313 12.155 1.45312 12.5 1.45312C12.845 1.45312 13.125 1.73313 13.125 2.07812V4.99479C13.125 5.10979 13.2183 5.20312 13.3333 5.20312H16.25C16.595 5.20312 16.875 5.48312 16.875 5.82812C16.875 6.17312 16.595 6.45312 16.25 6.45312H13.3333C12.5275 6.45312 11.875 5.80062 11.875 4.99479V2.07812Z",
    fill: "#00B3B5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66602 9.375C6.32102 9.375 6.04102 9.095 6.04102 8.75C6.04102 8.405 6.32102 8.125 6.66602 8.125H13.3327C13.6777 8.125 13.9577 8.405 13.9577 8.75C13.9577 9.095 13.6777 9.375 13.3327 9.375H6.66602Z",
    fill: "#00B3B5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66602 12.2969C6.32102 12.2969 6.04102 12.0169 6.04102 11.6719C6.04102 11.3269 6.32102 11.0469 6.66602 11.0469H13.3327C13.6777 11.0469 13.9577 11.3269 13.9577 11.6719C13.9577 12.0169 13.6777 12.2969 13.3327 12.2969H6.66602Z",
    fill: "#00B3B5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66602 15.2031C6.32102 15.2031 6.04102 14.9231 6.04102 14.5781C6.04102 14.2331 6.32102 13.9531 6.66602 13.9531H10.416C10.761 13.9531 11.041 14.2331 11.041 14.5781C11.041 14.9231 10.761 15.2031 10.416 15.2031H6.66602Z",
    fill: "#00B3B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveDocumentFlexiLoan);
export default __webpack_public_path__ + "static/media/active-document-flexi-loan.ecff411bf8ec7c73c1d74057524483d5.svg";
export { ForwardRef as ReactComponent };